"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasisTheoryThreeDs = require("./BasisTheoryThreeDs");

Object.keys(_BasisTheoryThreeDs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasisTheoryThreeDs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasisTheoryThreeDs[key];
    }
  });
});